import productsColumn from '@/activities/handsontable/columns/products';
import { ColumnSettingsSubtable } from '@/shared/handsontable/rework/features/nestedTable/types';

const activities: ColumnSettingsSubtable = {
  ...productsColumn,
  readOnly: true,
};

export default activities;
